import * as NS from './namespace';
import { Module } from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

/**
 * Состояние по умолчанию модуля администрирования
 */
const defaultState: NS.IAdministrationState = {
    preloader: false,
    failLoading: false,
    activeFormRequest: false,
    failedFormRequest: false,

    usersGrid: [],
    chooseDevicesData: [],
    indicatorsGrid: [],
    devicesGrid: [],
    chooseIndicatorData: [],
};

const AdministrationModule: Module<NS.IAdministrationState, NS.IAdministrationState> = {
    namespaced: true,
    actions: {
        ...actions,
    },
    getters: {
        ...getters,
    },
    mutations: {
        ...mutations,
    },
    state: {
        ...defaultState,
    },
};

/**
 * Модуль администрирования для хранилища
 */
export default AdministrationModule;